import React, { createContext, useState } from 'react';
import { themes } from '../styles/themes';

export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [currentTheme, setCurrentTheme] = useState('chauffeur');

  return (
    <ThemeContext.Provider value={{ theme: themes[currentTheme], setCurrentTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
